import { BehaviorSubject } from 'rxjs';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { FatDoctoCService } from 'app/shared/services/fat-docto-c.service';
import { LancamentoDetailsComponent } from 'app/views/movimentacao/faturamento/lancamento/lancamento-details/lancamento-details.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MovtoDetails } from 'app/shared/interfaces/movto-details';
import * as moment from 'moment';
import { MatTabGroup } from '@angular/material/tabs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PageResult } from 'app/shared/interfaces/page-result';
import { ProdutoMovto } from 'app/shared/interfaces/produto-movto';

@Component({
  selector: 'app-produto-movto-popup',
  templateUrl: './produto-movto-popup.component.html',
  styleUrls: ['./produto-movto-popup.component.scss']
})
export class ProdutoMovtoPopupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  produtoForm: FormGroup;
  produto: Produto;
  layoutConf: any;
  detailsMovto: MovtoDetails;
  dataFinal = moment(new Date(), 'DD/MM/YYYY').toDate().toISOString().split('T')[0];
  dataInicial = moment(new Date(new Date().setDate(new Date().getDate() - 30)), 'DD/MM/YYYY').toDate().toISOString().split('T')[0];
  pageObject$: BehaviorSubject<PageResult<ProdutoMovto>> = new BehaviorSubject<PageResult<ProdutoMovto>>(null);
  
  movtos: ProdutoMovto[];
  page = 1;
  length = 0;
  pageSize = 5;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25];

  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';
  selectedTabIndex = 0;
  
  locationUrl = '/produto_detail/';
  changeLocationUrl = this.locationUrl;
  isSaving: boolean;

  // produtoSelected: Produto;


   /**
   * Ao Teclar Esc
   */
    @HostListener('window:keyup.esc') onKeyUp() {
      if (this.dialog.openDialogs.length > 0) {
        console.log('@HostListener(window:keyup.esc) onKeyUp()');
        this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
          .subscribe(res => {
            if (res) {
              this.dialogRef.close();
            }
          });
      }
    }
    
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoMovtoPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private loader: AppLoaderService,
    private layout: LayoutService,
    private fatDoctoCService: FatDoctoCService,
    private produtoService: ProdutoService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
  ) { }
  
 

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.produto = this.data.payload;
    console.log(`Produto: ${this.produto.codigo} - ${this.produto.descricao}`);

    this.buildProdutoForm()

    this.produtoService.getMovtoDetails(this.produto?.id.toString()).subscribe(movto => {this.detailsMovto = movto});
    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.movtos = page.content;
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
          if (this.page === 1) {
            this.paginator?.firstPage();
          }
        } else {
          this.movtos = [];
        }
      });
   this.reloadPageMovto(); 
      

  }

  buildProdutoForm() {
    this.produtoForm = this.fb.group({
      dataInicial: [this.dataInicial],
      datFinal: [this.dataFinal],
    })

  }

  private changeUrl() {
    this.changeLocationUrl = this.locationUrl + this.produto?.id + '/' + this.selectedTabIndex;
  }

  setSelectedTabIndex(event: MatTabGroup) {
    this.selectedTabIndex = event.selectedIndex;
    this.changeUrl();
    if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Movimenta') > -1) {
      this.getPageMovto(this.page, this.pageSize, this.produto.id, this.dataInicial, this.dataFinal);
    } else if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Endere') > -1) {
    }
  }

  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.getPageMovto(event.pageIndex + 1, event.pageSize, this.produto.id, this.dataInicial, this.dataFinal);
  }

  getPageMovto(page: number, pageSize: number, id: number, dataInicial: string, dataFinal: string) {
    if (id !== undefined) {
      this.produtoService.getMovto(page, pageSize, this.selectedOrdem
        , this.selectedDirect, id.toString(), dataInicial, dataFinal).subscribe(val => { this.pageObject$.next(val) })
    }
  }

  reloadPageMovto() {
    this.page = 1;
    this.getPageMovto(this.page, this.pageSize, this.produto.id, this.dataInicial, this.dataFinal);
  }



  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  openLcto(controle: number) {
    if (!controle) return;
    this.loader.open();
    this.fatDoctoCService.getFatDoctoC(controle).subscribe(
      val => {
        this.loader.close();
        const lctoRef = this.dialog.open(LancamentoDetailsComponent, {
          width: this.layoutConf?.isMobile ? '100vw' : '98%',
          maxWidth: '100vw',
          height: this.layoutConf?.isMobile ? '100dvh' : '90vh',
          maxHeight: '100dvh',
          disableClose: true,
          panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
          data: { payload: val, openAsModal: true },
        });
        lctoRef.backdropClick().subscribe(() => {
          if (this.dialog.openDialogs.length > 0) {
            const cn = confirm('Deseja realmente sair?');
            if (cn) lctoRef.close();
          }
        });
        lctoRef.afterClosed().subscribe(() => {
          this.reloadPageMovto();
        });
      },
      err => {
        this.loader.close();
        this.confirmService.confirm({ message: `ERRO AO CARREGAR LCTO: ${err}`, error: true });
      }
    );
  }

  submit() {
   
  }

  close() { 
    this.dialogRef.close();
  }

}
